<template>
  <div>
    <a-card :bordered="false">
      <div class="box">
         <!-- 用于显示转换后的图片 -->
          <img v-if="imageUrl" :src="imageUrl" alt="预览图" class="image"/>
          <a-upload
          :before-upload="beforeUpload"
          :file-list="[]"
          :show-upload-list="false"
          list-type="picture-card"
          accept="image/*"
        >
          <div :style="{width:'150px', height:'120px'}">
            <p class="ant-upload-drag-icon">
              <a-icon type="inbox" :style="{ fontSize: '50px' }" />
            </p>
            <p class="ant-upload-text" :style="{paddingTop:'10px'}">
              选择图片
            </p>
            <p class="ant-upload-hint" :style="{color: 'red',paddingTop:'20px',fontSize:'12px'}">
              (文件大小需小于1MB)
            </p>
          </div>
        </a-upload>
      </div>
      <div class="account-box">
        <a-button type="primary" @click="save" :loading="loading">确认上传文件</a-button>
      </div>
      <div v-if="signAuthFileId" style="margin-top: 20px;">
        <a-descriptions title="文件信息">
          <a-descriptions-item label="文件ID">{{signAuthFileId}}</a-descriptions-item>
        </a-descriptions>
      </div>
    </a-card>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "MerchantSignAuthFile",
  data() {
    return {
      loading: false,
      userInfo: null,
      merchantNo: "", // 商户编号
      imageUrl: "",
      signAuthFileId: ""
    };
  },
  created() {
    this.userInfo = this.$store.getters.userInfo;
    this.merchantNo = this.userInfo.merchantNo;
    this.merchantInfo = this.userInfo.merchant.merchantInfo;
    if(this.userInfo.merchant.merchantInfo){
      this.signAuthFileId = this.userInfo.merchant.merchantInfo.signAuthFileId || "";
    }
  },
  methods: {
    ...mapActions(["SetUserInfo"]),
    async getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
      });
    },
    async beforeUpload(file){
      const isLt2M = file.size / 1024 / 1024 < 1;
      if (!isLt2M) {
        message.error('图片大小不能超过 1MB!');
        return false;
      }
      // 2. 将文件转为 Base64
      try {
        const base64 = await this.getBase64(file);
        this.imageUrl = base64; // 赋值给 data 中的变量用于预览
        // 你也可以将 base64 保存到其他状态中，用于后续提交
        // console.log('图片的 Base64 字符串:', base64);
      } catch (error) {
        console.log(error)
      }

      // 3. 返回 false 阻止自动上传
      return false;
    },
    save() {
      let param = {};
      if (!this.imageUrl) {
        this.$message.info("请选择文件");
        return;
      }
      param.merchantNo = this.merchantNo;
      param.fileBase64Content = this.imageUrl;
      this.loading = true;
      this.$http.roomBksApi
        .settingMerchantSignAuthFile(param)
        .then(res => {
          if (res && res.result == 0) {
            this.$message.success("文件上传成功");
            this.signAuthFileId = res.resultObject;
            this.userInfo.merchant.merchantInfo.signAuthFileId = this.signAuthFileId;
            this.SetUserInfo(this.userInfo);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="less" scoped>
.opt {
  a {
    margin: 0 5px;
  }
}

.operation {
  text-align: center;
  margin: 20px auto 5px;
  button {
    margin: 0 10px;
  }
}
.tips {
  margin-top: 20px;
  color: red;
}
.box {
  display: flex;
  .image {
    width: 150px;
    height: 138px;
    margin-right: 10px;
  }
}
</style>
